var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"correctness-header"},[_c('radio-button',{attrs:{"correct":_vm.correct,"answered":true,"selected":true,"size":"large"}}),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }